module.exports = __webpack_public_path__ + "static/media/pm_aff.f37ddc95.svg";